export enum TaskType {
  Upload = 'upload',
  Download = 'download',
  Generic = 'generic',
}
